// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-scroll-container[data-v-5a591b2c] {\n  max-height: 400px;\n  overflow-y: auto;\n  margin-top: 8px;\n}\n.template-page-tile .label[data-v-5a591b2c] {\n  margin-bottom: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
